module.exports = __webpack_public_path__ + "static/tfk_logo-1087a01b69dbfb42be100cd2b4cfd01d.png";